import './bottom.css'
import { MdOutlineCopyright } from "react-icons/md";
import { FaInstagram } from "react-icons/fa";
export default function Bottom() {
    return (
        <>
            <div className='bottomly'>
                <div className="f1">
                    <div className='specially'>
                        The BITS Herald
                    </div>
                    <div className='ok'>
                        {<MdOutlineCopyright className='iconfr' />}2025 - All rights reserved. The Bits Herald, BITS Goa
                    </div>
                </div>
                <div className="f1">
                    <div className='ok1 ok'>
                        Edited and Managed by:
                    </div>
                    <div className='ok ok2'>
                        Dhruv Sinha <br /> Rishika Gupta <br /> Aditya Prakash <br /> Ishaan Gulati
                    </div>
                </div>
                <div className="f1">
                    <a href="https://www.instagram.com/thebitsherald/" className="DojmaSocial2" target="blank">
                        <FaInstagram className="DojmaSocial22" />
                    </a>
                </div>
            </div>
        </>
    )
}